module.exports = __webpack_public_path__ + "media/intro.6c1128cc.mp4";